import { useTranslation } from "react-i18next";
import Tabs from "src/components/layout/Tabs";
import ListItem from "src/components/lists/list-items/ListItem";
import useExampleTask from "src/hooks/data/useExampleTasks";
import { formatPrice } from "src/lib/formatters";

const ExampleTaskList = () => {
	const { categories, tasks } = useExampleTask();
	const { t } = useTranslation("common");

	return (
		<div className=" ">
			<Tabs
				tabs={categories}
				options={{
					noBackground: true,
					scrollToActive: true,
					small: true,
					variant: "dropdown",
				}}
				renderTab={(label) => (
					<small className="leading-1">{label}</small>
				)}
			>
				{(tab) => (
					<>
						<div className="flex flex-col gap-4">
							{tasks[tab] &&
								typeof tasks[tab] === "object" &&
								(tasks[tab] || []).map(
									(item: any, index: number) => (
										<ListItem
											key={`tab-${item.title}`}
											to={`/tasks/create?title=${item.title}&budget=${item.budget}`}
										>
											<ListItem.Content className="gap-1">
												<ListItem.Title className="max-w-[90%]">
													{item.title}
												</ListItem.Title>
												<ListItem.Text>
													{t("labels.average")}{" "}
													{formatPrice(item.budget)}
												</ListItem.Text>
											</ListItem.Content>
										</ListItem>
									)
								)}
						</div>
					</>
				)}
			</Tabs>
		</div>
	);
};

export default ExampleTaskList;
